import type { AnySelfOwnedWidgetClass } from './selfOwnedWidget';
import type { WidgetType } from '@thinkalpha/ui-types/contracts/workspace';
import { AlphaEyeWidgetModelImpl } from 'src/models/AlphaEyeWidgetModel/impl';
import { NotepadWidgetModelImpl } from 'src/models/NotepadWidgetModel/impl';
import { PlatformsWidgetModelImpl } from 'src/models/PlatformsWidgetModel/impl';
import { SymbolsWidgetModelImpl } from 'src/models/SymbolsWidgetModel/impl';
import { TradersWidgetModelImpl } from 'src/models/TradersWidgetModel/impl';
import type { LegacyWidgetViewModel, SelfOwnedWidgetViewModel, WidgetViewModel } from 'src/store/types';

export const selfOwnedWidgetRegistry: ReadonlyMap<WidgetType, AnySelfOwnedWidgetClass> = new Map<
    WidgetType,
    AnySelfOwnedWidgetClass
>([
    ['alpha-eye', AlphaEyeWidgetModelImpl],
    ['notepad', NotepadWidgetModelImpl],
    ['platforms', PlatformsWidgetModelImpl],
    ['symbols', SymbolsWidgetModelImpl],
    ['traders', TradersWidgetModelImpl],
]);

export function isSelfOwnedWidget(widget: WidgetViewModel): widget is SelfOwnedWidgetViewModel {
    return selfOwnedWidgetRegistry.has(widget.type);
}

export function isLegacyWidget(widget: WidgetViewModel): widget is LegacyWidgetViewModel {
    return !selfOwnedWidgetRegistry.has(widget.type);
}
